var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "app-side-menu",
    { attrs: { "min-width": 18, "fixed-menu": false } },
    [
      _c(
        "aside",
        {
          staticClass: "menu",
          attrs: { slot: "side-menu" },
          slot: "side-menu",
        },
        [
          _c("p", { staticClass: "menu-label" }, [
            _c("span", { staticClass: "title is-6" }, [
              _vm._v(" INVOICE No: "),
            ]),
          ]),
          _c(
            "ul",
            { staticClass: "menu-list" },
            _vm._l(_vm.invoices, function (invoice) {
              return _c("li", { key: invoice.invoiceID }, [
                _vm._v(" " + _vm._s(invoice.invoiceRef) + " "),
              ])
            }),
            0
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }